import Link from 'next/link'
import { type FC, memo } from 'react'
import styled from 'styled-components'

import SvgLogo from 'assets/svg/brand/logo.svg'
import ROUTES from 'constants/routes'
import { selectPerpsProvider } from 'state/futures/common/selectors'
import { selectOpenPositionAsset } from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'
import media from 'styles/media'

const Logo: FC = memo(() => {
	const perpsProvider = useAppSelector(selectPerpsProvider)
	const marketAsset = useAppSelector(selectOpenPositionAsset)

	return (
		<Link href={ROUTES.Markets.Home(perpsProvider, marketAsset)}>
			<LogoContainer>
				<SvgLogo />
			</LogoContainer>
		</Link>
	)
})

const LogoContainer = styled.span`
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 125px;
	margin-right: 16px;
	${media.lessThan('md')`
		width: 120px;
	`}
`

export default Logo
